var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAccount = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 12,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M12.668 7.333V2c0-.733-.6-1.333-1.333-1.333H2C1.268.667.668 1.267.668 2v5.333c0 .734.6 1.334 1.333 1.334h9.334c.733 0 1.333-.6 1.333-1.334m-6-.666c-1.107 0-2-.894-2-2 0-1.107.893-2 2-2s2 .893 2 2-.893 2-2 2m8.667-4V10c0 .733-.6 1.333-1.334 1.333H2.668V10h11.333V2.667z"
})));
export default SvgAccount;